import React from 'react';
import { useDispatch } from 'react-redux';
import { userModeChange } from 'Store/UserInfo/Actions';

const MobileInstructorView = ({ title = "Instructor Mode" }) => {
  const dispatch = useDispatch();

  const handleModeChange = () => {
    dispatch(userModeChange('S'));
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "80vh" }}>
      {/* <h4 className="mb-4">{title}</h4> */}
      <button 
        className="btn btn-primary" 
        onClick={handleModeChange}
      >
        Switch to Student Mode
      </button>
      <p className="mt-4 text-muted text-center px-2">
        Please use a larger screen to access the Instructor features
      </p>
    </div>
  );
};

export default MobileInstructorView;